import { useEffect, useState } from "react";
import MESSAGES from "../../../../common/data/constants/messages";
import { IWorkResourceEmployee } from "../../../../common/data/dtos/work-resource-employee";
import ReturnStatusEnum from "../../../../common/data/enums/enumReturnStatus";
import WorkResourceEmployeeStatusEnum from "../../../../common/data/enums/enumWorkResourceEmployeeStatus";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardFooterRight, CardTabItem } from "../../../../components/bootstrap/Card";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../components/bootstrap/Modal";
import Spinner from "../../../../components/bootstrap/Spinner";
import FormGroup from "../../../../components/bootstrap/forms/FormGroup";
import Select from "../../../../components/bootstrap/forms/Select";
import { showSuccess, showWarning } from "../../../../components/extras/Notifications";
import workResourceEmployeeService from "../../../../services/work-resource-employee-service";

interface Props {
    isModalOpened: boolean;
    selectedWorkResourceEmployee: IWorkResourceEmployee | null;
    onModalClose: () => void;
    onAfterSubmit: () => void;
}

export const ReturnWorkResourceModal = ({ isModalOpened, selectedWorkResourceEmployee, onModalClose, onAfterSubmit }: Props) => {

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [selectedReturnStatus, setSelectedReturnStatus] = useState<string>('');

    useEffect(() => {

        if (selectedWorkResourceEmployee) {
            setSelectedReturnStatus('');
        }

    }, [isModalOpened]);

    const onClose = () => {
        onModalClose();
    };

    const onFormSubmit = async () => {

        if (selectedWorkResourceEmployee) {

            setIsSubmitting(true);

            const returnStatus: ReturnStatusEnum = ReturnStatusEnum[selectedReturnStatus as keyof typeof ReturnStatusEnum];

            const response = await workResourceEmployeeService.updateWorkResourceEmployee({
                id: selectedWorkResourceEmployee.id,
                quantity: selectedWorkResourceEmployee.quantity,
                deliveryDate: selectedWorkResourceEmployee.deliveryDate,
                situation: WorkResourceEmployeeStatusEnum.returned,
                employeeId: selectedWorkResourceEmployee.employeeId,
                workResourceId: selectedWorkResourceEmployee.workResourceId,
                rowVersion: selectedWorkResourceEmployee.rowVersion,
                status: selectedWorkResourceEmployee.status,
                returnStatus: returnStatus,
                returnDate: new Date(),
                sign: selectedWorkResourceEmployee.sign
            });

            setIsSubmitting(false);

            if (response.error) {
                showWarning(MESSAGES.ACTION.EDIT_ERROR);
                return;
            }

            showSuccess(MESSAGES.ACTION.EDITED);
            onAfterSubmit();
        }
    }

    return (
        <>
            <Modal isOpen={isModalOpened} setIsOpen={onClose} size={'lg'} isCentered isStaticBackdrop>
                <ModalHeader setIsOpen={onClose}>
                    <ModalTitle id='return-work-resource-modal'>Devolução de ferramentas e EPI</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <Card hasTab tabButtonColor='primary' >
                        <CardTabItem id='tab-item-1' title={'Devolução'} icon='AssignmentReturn'>
                            <div className='row g-4'>
                                <div className='col-lg-12 col-md-12 col-sm-12'>
                                    <FormGroup
                                        id='redturnStatus'
                                        label='Motivo da Devolução'
                                        isFloating
                                    >
                                        <Select
                                            ariaLabel='Escolha um motivo'
                                            onChange={(e: { target: { value: any } }) => {
                                                if (e.target.value) {
                                                    setSelectedReturnStatus(e.target.value);
                                                }
                                            }}
                                            list={
                                                [
                                                    { value: '1', text: 'Desgaste normal' },
                                                    { value: '2', text: 'Perda' },
                                                    { value: '3', text: 'Danificado' },
                                                    { value: '4', text: 'Substituição do modelo' },
                                                ]
                                            }
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </CardTabItem>
                    </Card>
                </ModalBody>
                <ModalFooter className='bg-transparent'>
                    <CardFooterRight>
                        <Button color='success' className='w-100' onClick={onFormSubmit} isDisable={isSubmitting}>
                            {isSubmitting && <Spinner isSmall inButton isGrow />}
                            Salvar
                        </Button>
                    </CardFooterRight>
                </ModalFooter>
            </Modal>
        </>
    );
}